import { get } from '../../api';
import { DefaultResponseDTO, Resource } from '../../constants';

export const getResourcesRequest = (resourceName: string, query?: string): Promise<DefaultResponseDTO<Resource[]>> => {
  return get<DefaultResponseDTO<Resource[]>>(`/${resourceName}/dropdown?${query}`);
};
